import type { MyDataAddress } from '../types'

export function formatAddress(address: MyDataAddress): string | null {
  const parts = [
    [address.logradouro, address.numero].filter(Boolean).join(', '),
    address.complemento,
    address.bairro,
    address.cidade,
    address.estado,
    address.cep,
    address.pais
  ].filter(Boolean)

  return parts.length ? parts.join(' - ') : null
}

// Tela LGPD de transparência: formatamos (não mascaramos) os dados do próprio
// aluno — o objetivo é mostrar com clareza o que guardamos.
export function formatCpf(value: string | null | undefined): string | null {
  if (!value) return null
  const digits = value.replace(/\D/g, '')
  if (digits.length !== 11) return value
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`
}

export function formatPhone(value: string | null | undefined): string | null {
  if (!value) return null
  const digits = value.replace(/\D/g, '')
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
  }
  return value
}
